export default { 
 
    mutation_id_para_imprimir( state, valor) {   
                 state.id_para_imprimir   = valor 
               
    },

}